module.exports = __webpack_public_path__ + "static/the-book-of-qualities-29e1b2210cce467df06d875384a8c6ba.jpg";